import { defineComponent as i, openBlock as l, createElementBlock as o, mergeProps as u, unref as e, renderSlot as g, createElementVNode as n, createCommentVNode as m } from "vue";
import { useScalarIcon as f } from "../hooks/useScalarIcon.js";
const k = { key: 0 }, M = { key: 1 }, Z = { key: 2 }, h = { key: 3 }, w = { key: 4 }, y = { key: 5 }, _ = {
  name: "ScalarIconCaretLeft"
}, C = /* @__PURE__ */ i({
  ..._,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: d, weight: a } = f(s);
    return (p, t) => (l(), o("svg", u({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(d)), [
      g(p.$slots, "default"),
      e(a) === "bold" ? (l(), o("g", k, t[0] || (t[0] = [
        n("path", { d: "M168.49,199.51a12,12,0,0,1-17,17l-80-80a12,12,0,0,1,0-17l80-80a12,12,0,0,1,17,17L97,128Z" }, null, -1)
      ]))) : e(a) === "duotone" ? (l(), o("g", M, t[1] || (t[1] = [
        n("path", {
          d: "M160,48V208L80,128Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M163.06,40.61a8,8,0,0,0-8.72,1.73l-80,80a8,8,0,0,0,0,11.32l80,80A8,8,0,0,0,168,208V48A8,8,0,0,0,163.06,40.61ZM152,188.69,91.31,128,152,67.31Z" }, null, -1)
      ]))) : e(a) === "fill" ? (l(), o("g", Z, t[2] || (t[2] = [
        n("path", { d: "M168,48V208a8,8,0,0,1-13.66,5.66l-80-80a8,8,0,0,1,0-11.32l80-80A8,8,0,0,1,168,48Z" }, null, -1)
      ]))) : e(a) === "light" ? (l(), o("g", h, t[3] || (t[3] = [
        n("path", { d: "M164.24,203.76a6,6,0,1,1-8.48,8.48l-80-80a6,6,0,0,1,0-8.48l80-80a6,6,0,0,1,8.48,8.48L88.49,128Z" }, null, -1)
      ]))) : e(a) === "regular" ? (l(), o("g", w, t[4] || (t[4] = [
        n("path", { d: "M165.66,202.34a8,8,0,0,1-11.32,11.32l-80-80a8,8,0,0,1,0-11.32l80-80a8,8,0,0,1,11.32,11.32L91.31,128Z" }, null, -1)
      ]))) : e(a) === "thin" ? (l(), o("g", y, t[5] || (t[5] = [
        n("path", { d: "M162.83,205.17a4,4,0,0,1-5.66,5.66l-80-80a4,4,0,0,1,0-5.66l80-80a4,4,0,1,1,5.66,5.66L85.66,128Z" }, null, -1)
      ]))) : m("", !0)
    ], 16));
  }
});
export {
  C as default
};
